import { useEffect, useContext } from "react";
import { BrowserRouter } from "react-router-dom";
import AppContent from "./AppContent";
import { AuthProvider, AuthContext } from "./state/AuthContext";
import useOnlineStatus from "./Hooks/useOnlineStatus";
import { safeGet } from "./utils/safeStorage";

function AppWithPresence() {
  const { currentUser, isAuthenticated } = useContext(AuthContext);
  // #591: render-time read on every route — safe accessor, never a raw one.
  const token = safeGet("token");
  useOnlineStatus(currentUser?.id, token, isAuthenticated);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js")
        .catch(() => console.log("Service worker registration failed"));
    }
  }, []);

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppContent />
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppWithPresence />
    </AuthProvider>
  );
}

export default App;
